export default function TranscriptTab({ consultation }) {
  return (
    <div className="text-gray-900 text-base">
      {consultation?.transcript || "No transcript available"}
    </div>
  );
}
